import React from 'react'
import VisitWebsitePNG from "../../../assets/icons/visit-website.png"
export const VisitWebsite: React.FC = () => {
  return (
    <img src={VisitWebsitePNG} alt="" className="w-[111px] h-[22px]" />
  )
}
